export default "__VITE_ASSET__CIxk1uTs__"